import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import AccountReducer from "./auth/register/reducer";
// import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import LoginReducer from "./auth/login/reducer";
import ProfileReducer from "./auth/profile/reducer";
import AdminProfileReducer from "./profile/reducer";

// Events
import EventSongListReducer from "./event/view/reducer";
import EventUsersListReducer from "./event/user/list/reducer";
import EventSongDeleteReducer from "./event/song/delete/reducer";
import EventSongNoteReducer from "./event/song/note/reducer";
import EventSongEditReducer from "./event/song/edit/reducer";
import DedicationReducer from "./event/dedication/reducer";
import EventReducer from "./event/details/reducer";
import EventSongAddReducer from "./event/song/add/reducer";
import EventSongVote from "./event/song/vote/reducer";
import EventSongReorderReducer from "./event/song/reorder/reducer";
// Users
import UserListReducer from "./user/list/reducer";
import UserDeleteReducer from "./user/delete/reducer";
import UserAddReducer from "./user/add/reducer";
import UserReducer from "./user/details/reducer";
import TipReducer from './tip/reducer';
import TipsList from './tip/list/reducer';
import AdminUserTipsReducer from './tip/userTips/reducer';
// Songs
import SongListReducer from "./song/reducer";
import SongLibraryListReducer from "./song/list/reducer";
import SongLibraryReducer from "./songLibrary/reducer";
import SongLibrarySongReducer from "./songLibrarySong/reducer";

// Message
import MessageAddReducer from "./message/add/reducer";


const rootReducer = combineReducers({
  EventSongReorder: EventSongReorderReducer,
  Layout: LayoutReducer,
  Login: LoginReducer,
  Account: AccountReducer,
  Tip: TipReducer,
  TipList: TipsList,
  AdminUserTips: AdminUserTipsReducer,
  // ForgetPassword: ForgetPasswordReducer,
  Profile: ProfileReducer,
  AdminProfile: AdminProfileReducer,
  SongList: SongListReducer,
  SongLibraryList: SongLibraryListReducer,
  SongLibrary: SongLibraryReducer,
  SongLibrarySong: SongLibrarySongReducer,
  EventSongList: EventSongListReducer,
  UserList: UserListReducer,
  UserDelete: UserDeleteReducer,
  UserAdd: UserAddReducer,
  MessageAdd: MessageAddReducer,
  User: UserReducer,
  Event: EventReducer,
  EventUsersList: EventUsersListReducer,
  EventSongDelete: EventSongDeleteReducer,
  EventSongNote: EventSongNoteReducer,
  EventSongEdit: EventSongEditReducer,
  Dedication: DedicationReducer,
  EventSongAdd: EventSongAddReducer,
  EventSongVote: EventSongVote
});

export default rootReducer;
